import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AdiantamentoEditarRoutingModule } from './adiantamento-editar-routing.module';
import { AdiantamentoEditarComponent } from './adiantamento-editar.component';
import { FormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { DividerModule } from 'primeng/divider';
import { MessagesModule } from 'primeng/messages';
import { InputMaskModule } from 'primeng/inputmask';
import { DropdownModule } from 'primeng/dropdown';
import { CalendarModule } from 'primeng/calendar';
import { InputNumberModule } from 'primeng/inputnumber';
import { TableModule } from 'primeng/table';
import { TooltipModule } from 'primeng/tooltip';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService } from 'primeng/api';
import { DialogModule } from 'primeng/dialog';


@NgModule({
  declarations: [
    AdiantamentoEditarComponent
  ],
  imports: [
    CommonModule,
    AdiantamentoEditarRoutingModule,
    FormsModule,
    TableModule,
    InputTextModule,
    ButtonModule,
    TooltipModule,
    DividerModule,
    MessagesModule,
    InputMaskModule,
    DropdownModule,
    CalendarModule,
    InputNumberModule,
    ProgressSpinnerModule,
    ConfirmDialogModule,
    DialogModule
  ],
  providers: [ConfirmationService]
})
export class AdiantamentoEditarModule { }
